import { getRoleRef } from "db";

export const SET_CURRENT_USER = 'set_current_user';
export const SET_CURRENT_ROLE = 'set_current_role';
export const SIGN_UP_USER = 'sign_up_user';

export const setCurrentUser = (currentUser) => dispatch => {
  dispatch({
    type: SET_CURRENT_USER,
    payload: currentUser
  })
}

export const getRoleAction = () => (dispatch, getState) => {
  const { uid } = getState().auth.currentUser;
  if (!uid) {
    console.log('uid is required');
  }
  return getRoleRef(uid)
    .onSnapshot(docSnap => {
      dispatch({
        type: SET_CURRENT_ROLE,
        payload: docSnap.data()
      })
    }, err => {
      console.log(`Encountered error: ${err}`);
    });
}

export const signUp = (userInfo) => dispatch => {
  dispatch({
    type: SIGN_UP_USER,
    payload: userInfo
  })
}